var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "mb12" },
        [
          _c("oaFromBox", {
            staticClass: "from-box",
            attrs: {
              isAddBtn: false,
              isTotal: false,
              isViewSearch: false,
              search: _vm.search,
              sortSearch: false,
            },
            on: { confirmData: _vm.confirmData },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "item-info-card" },
        [
          _c(
            "el-row",
            { staticClass: "elRow", attrs: { gutter: 24 } },
            [
              _c("el-col", { attrs: { lg: 8, md: 6, sm: 12, xl: 4 } }, [
                _c(
                  "div",
                  { staticClass: "item-info-list" },
                  [
                    _c("el-card", [
                      _c("div", { staticClass: "item" }, [
                        _c(
                          "div",
                          { staticClass: "item-top" },
                          [
                            _c("div", { staticClass: "tit over-text" }, [
                              _vm._v("总收入（元）"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "top-start",
                                  trigger: "hover",
                                  width: "150",
                                },
                              },
                              [
                                _c("div", { staticClass: "text-align" }, [
                                  _vm._v(
                                    "\n                    环比" +
                                      _vm._s(
                                        _vm.income.ratio > 0 ? "增加" : "减少"
                                      ) +
                                      "\n                    "
                                  ),
                                  _vm.income.ratio > 0
                                    ? _c("span", [
                                        _vm._v(_vm._s(_vm.income.ratio) + "%"),
                                      ])
                                    : _vm.income.ratio < 0
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("absNum")(_vm.income.ratio)
                                          ) + "%"
                                        ),
                                      ])
                                    : _c("span", [_vm._v("0%")]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "img-box",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _vm.income.ratio > 0
                                      ? _c("span", {
                                          staticClass:
                                            "iconfont icontongji-shangzhang",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.income.ratio < 0
                                      ? _c("span", {
                                          staticClass:
                                            "iconfont icontongji-xiajiang",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        class:
                                          _vm.income.ratio > 0 ? "per" : "fper",
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.income.ratio > 0 ? "+" : ""
                                            ) +
                                            _vm._s(_vm.income.ratio || 0) +
                                            "%\n                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "num" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.income.price || 0) +
                              "\n              "
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { lg: 8, md: 6, sm: 12, xl: 4 } }, [
                _c(
                  "div",
                  { staticClass: "item-info-list" },
                  [
                    _c("el-card", [
                      _c("div", { staticClass: "item" }, [
                        _c(
                          "div",
                          { staticClass: "item-top" },
                          [
                            _c("div", { staticClass: "tit over-text" }, [
                              _vm._v(_vm._s(_vm.$t("customer.newcustomer"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "top-start",
                                  trigger: "hover",
                                  width: "150",
                                },
                              },
                              [
                                _c("div", { staticClass: "text-align" }, [
                                  _vm._v(
                                    "\n                    环比" +
                                      _vm._s(
                                        _vm.new_customer.ratio > 0
                                          ? "增加"
                                          : "减少"
                                      ) +
                                      "\n                    "
                                  ),
                                  _vm.new_customer.ratio > 0
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.new_customer.ratio) + "%"
                                        ),
                                      ])
                                    : _vm.new_customer.ratio < 0
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("absNum")(
                                              _vm.new_customer.ratio
                                            )
                                          ) + "%"
                                        ),
                                      ])
                                    : _c("span", [_vm._v("0%")]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "img-box",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _vm.new_customer.ratio > 0
                                      ? _c("span", {
                                          staticClass:
                                            "iconfont icontongji-shangzhang",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.new_customer.ratio < 0
                                      ? _c("span", {
                                          staticClass:
                                            "iconfont icontongji-xiajiang",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        class:
                                          _vm.new_customer.ratio > 0
                                            ? "per"
                                            : "fper",
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.new_customer.ratio > 0
                                                ? "+"
                                                : ""
                                            ) +
                                            _vm._s(
                                              _vm.new_customer.ratio || 0
                                            ) +
                                            "%\n                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "num" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.new_customer.count || 0) +
                              "\n              "
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { lg: 8, md: 6, sm: 12, xl: 4 } }, [
                _c(
                  "div",
                  { staticClass: "item-info-list" },
                  [
                    _c("el-card", [
                      _c("div", { staticClass: "item" }, [
                        _c(
                          "div",
                          { staticClass: "item-top" },
                          [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "top-start",
                                  trigger: "hover",
                                },
                              },
                              [
                                _c("div", { staticClass: "text-align" }, [
                                  _vm._v("按开始日期统计"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "tit over-text hand",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("customer.newcontract"))
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "top-start",
                                  trigger: "hover",
                                  width: "150",
                                },
                              },
                              [
                                _c("div", { staticClass: "text-align" }, [
                                  _vm._v(
                                    "\n                    环比" +
                                      _vm._s(
                                        _vm.new_contract.ratio > 0
                                          ? "增加"
                                          : "减少"
                                      ) +
                                      "\n                    "
                                  ),
                                  _vm.new_contract.ratio > 0
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.new_contract.ratio) + "%"
                                        ),
                                      ])
                                    : _vm.new_contract.ratio < 0
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("absNum")(
                                              _vm.new_contract.ratio
                                            )
                                          ) + "%"
                                        ),
                                      ])
                                    : _c("span", [_vm._v("0%")]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "img-box",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _vm.new_contract.ratio > 0
                                      ? _c("span", {
                                          staticClass:
                                            "iconfont icontongji-shangzhang",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.new_contract.ratio < 0
                                      ? _c("span", {
                                          staticClass:
                                            "iconfont icontongji-xiajiang",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        class:
                                          _vm.new_contract.ratio > 0
                                            ? "per"
                                            : "fper",
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.new_contract.ratio > 0
                                                ? "+"
                                                : ""
                                            ) +
                                            _vm._s(
                                              _vm.new_contract.ratio || 0
                                            ) +
                                            "%\n                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "num" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.new_contract.count || 0) +
                              "\n              "
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticStyle: { "min-height": "1px" },
                  attrs: { lg: 8, md: 6, sm: 12, xl: 4 },
                },
                [
                  _c(
                    "div",
                    { staticClass: "item-info-list" },
                    [
                      _c("el-card", [
                        _c("div", { staticClass: "item" }, [
                          _c(
                            "div",
                            { staticClass: "item-top" },
                            [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "top-start",
                                    trigger: "hover",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "text-align" }, [
                                    _vm._v("按开始日期统计"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "tit hand over-text",
                                      attrs: { slot: "reference" },
                                      slot: "reference",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("customer.newamount"))
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "top-start",
                                    trigger: "hover",
                                    width: "150",
                                  },
                                },
                                [
                                  _c("div", { staticClass: "text-align" }, [
                                    _vm._v(
                                      "\n                    环比" +
                                        _vm._s(
                                          _vm.new_contract_price.ratio > 0
                                            ? "增加"
                                            : "减少"
                                        ) +
                                        "\n\n                    "
                                    ),
                                    _vm.new_contract_price.ratio > 0
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.new_contract_price.ratio
                                            ) + "%"
                                          ),
                                        ])
                                      : _vm.new_contract_price.ratio < 0
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("absNum")(
                                                _vm.new_contract_price.ratio
                                              )
                                            ) + "%"
                                          ),
                                        ])
                                      : _c("span", [_vm._v("0%")]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "img-box",
                                      attrs: { slot: "reference" },
                                      slot: "reference",
                                    },
                                    [
                                      _vm.new_contract_price.ratio > 0
                                        ? _c("span", {
                                            staticClass:
                                              "iconfont icontongji-shangzhang",
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.new_contract_price.ratio < 0
                                        ? _c("span", {
                                            staticClass:
                                              "iconfont icontongji-xiajiang",
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          class:
                                            _vm.new_contract_price.ratio > 0
                                              ? "per"
                                              : "fper",
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.new_contract_price.ratio > 0
                                                  ? "+"
                                                  : ""
                                              ) +
                                              _vm._s(
                                                _vm.new_contract_price.ratio ||
                                                  0
                                              ) +
                                              "%\n                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "num" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.new_contract_price.price || 0) +
                                "\n              "
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("el-col", { attrs: { lg: 8, md: 6, sm: 12, xl: 4 } }, [
                _c(
                  "div",
                  { staticClass: "item-info-list" },
                  [
                    _c("el-card", [
                      _c("div", { staticClass: "item" }, [
                        _c(
                          "div",
                          { staticClass: "item-top" },
                          [
                            _c("div", { staticClass: "tit over-text" }, [
                              _vm._v(
                                _vm._s(_vm.$t("customer.contractrenewal"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "top-start",
                                  trigger: "hover",
                                  width: "150",
                                },
                              },
                              [
                                _c("div", { staticClass: "text-align" }, [
                                  _vm._v(
                                    "\n                    环比" +
                                      _vm._s(
                                        _vm.renew.ratio > 0 ? "增加" : "减少"
                                      ) +
                                      "\n                    "
                                  ),
                                  _vm.renew.ratio > 0
                                    ? _c("span", [
                                        _vm._v(_vm._s(_vm.renew.ratio) + "%"),
                                      ])
                                    : _vm.renew.ratio < 0
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("absNum")(_vm.renew.ratio)
                                          ) + "%"
                                        ),
                                      ])
                                    : _c("span", [_vm._v("0%")]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "img-box",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _c("span", {
                                      class:
                                        _vm.renew.ratio > 0 ? "per" : "fper",
                                    }),
                                    _vm._v(" "),
                                    _vm.renew.ratio > 0
                                      ? _c("span", {
                                          staticClass:
                                            "iconfont icontongji-shangzhang",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.renew.ratio < 0
                                      ? _c("span", {
                                          staticClass:
                                            "iconfont icontongji-xiajiang",
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        class:
                                          _vm.renew.ratio > 0 ? "per" : "fper",
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.renew.ratio > 0 ? "+" : ""
                                            ) +
                                            _vm._s(_vm.renew.ratio || 0) +
                                            "%\n                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "num" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.renew.price || 0) +
                              "\n              "
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { lg: 8, md: 6, sm: 12, xl: 4 } }, [
                _c(
                  "div",
                  { staticClass: "item-info-list" },
                  [
                    _c("el-card", [
                      _c("div", { staticClass: "item" }, [
                        _c("div", { staticClass: "item-top" }, [
                          _c("div", { staticClass: "tit over-text" }, [
                            _vm._v(
                              _vm._s(_vm.$t("customer.uncollectedamount"))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "num" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.uncollected_price.price || 0) +
                              "\n              "
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 24 } },
            [
              _c("el-card", [
                _c("div", { staticClass: "statistics-title" }, [
                  _vm._v("业绩趋势"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("echartBox", {
                      attrs: {
                        "option-data": _vm.optionData1,
                        styles: _vm.styles1,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "el-col",
            { attrs: { lg: 12 } },
            [
              _c(
                "el-row",
                { staticClass: "mb14" },
                [
                  _c(
                    "el-card",
                    [
                      _c("div", { staticClass: "statistics-title" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("customer.departmentperformance")) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.frame_rank.length > 0
                        ? _c("div", { staticClass: "statistics-department" }, [
                            _c("div", { staticClass: "item" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "item" }),
                          ])
                        : _c("div", { staticClass: "default" }, [
                            _c("img", {
                              attrs: {
                                alt: "",
                                src: require("../../../assets/images/def1.png"),
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("public.message14") + "~")),
                            ]),
                          ]),
                      _vm._v(" "),
                      _vm.frame_rank.length > 0
                        ? _c("echartBox", {
                            attrs: {
                              "option-data": _vm.optionData,
                              styles: _vm.styles1,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("el-card", { staticStyle: { height: "525px" } }, [
                    _c("div", { staticClass: "statistics-title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("customer.contracttype")) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.contract_rank.length > 0
                      ? _c(
                          "div",
                          { staticClass: "ml10" },
                          [
                            _c(
                              "el-breadcrumb",
                              {
                                attrs: {
                                  "separator-class": "el-icon-arrow-right",
                                },
                              },
                              _vm._l(
                                _vm.breadcrumbList,
                                function (item, index) {
                                  return _c(
                                    "el-breadcrumb-item",
                                    {
                                      key: index,
                                      class: {
                                        breadcrumb: _vm.active == item.name,
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.changeActive(
                                                item,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.contract_rank.length > 0
                      ? _c(
                          "div",
                          { ref: "init", staticClass: "mt50" },
                          [
                            _c("echartBox", {
                              attrs: {
                                "option-data": _vm.pieChartData,
                                styles: _vm.styles1,
                              },
                              on: { pieChange: _vm.pieChange },
                            }),
                          ],
                          1
                        )
                      : _c("div", { staticClass: "default" }, [
                          _c("img", {
                            staticStyle: { width: "200px", height: "150px" },
                            attrs: {
                              alt: "",
                              src: require("../../../assets/images/def1.png"),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("public.message14") + "~")),
                          ]),
                        ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { lg: 12 } },
            [
              _c("el-card", [
                _c("div", { staticClass: "statistics-title" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("customer.salestop")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-box mt14 v-height-flag" }, [
                  _c(
                    "div",
                    { staticStyle: { height: "838px" } },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "table",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.tableData,
                            "default-expand-all": "",
                            "max-height": "800",
                            "row-key": "id",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              index: _vm.indexAdd,
                              label: _vm.$t("customer.ranking"),
                              type: "index",
                              width: "50",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("toptable.name"),
                              "min-width": "80",
                              prop: "name",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("toptable.department"),
                              "min-width": "80",
                              prop: "frame_name",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("customer.completeproportion"),
                              "min-width": "120",
                              prop: "ratio",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-progress", {
                                      attrs: {
                                        color: _vm.customColorMethod(scope.row),
                                        percentage: scope.row.ratio,
                                        "show-text": true,
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: _vm.$t("customer.completeamount"),
                              "min-width": "120",
                              prop: "price",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "支出金额（元）",
                              "min-width": "120",
                              prop: "expend",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "净额（元）",
                              "min-width": "120",
                              prop: "net_amount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }